// extracted by mini-css-extract-plugin
export var card = "_jn-5";
export var cardSelected = "_jn-4";
export var image = "_jn-3";
export var modal = "_jn-0";
export var modalContent = "_jn-1";
export var table = "_jn-2";